import React from 'react';
import './SuggestionsModal.css';

const SuggestionsModal = ({
  showSuggestions,
  setShowSuggestions,
  matchSuggestions,
  connectionRequests,
  handleConnectWithSuggestion
}) => (
  showSuggestions && (
    <div className="connections-suggestions-modal">
      <div className="connections-list">
        <div className="suggestions-header">
          <h3>Suggested Connections</h3>
          <button className="close-suggestions-btn" onClick={() => setShowSuggestions(false)}>×</button>
        </div>
        {matchSuggestions.length === 0 ? (
          <p>No matches found. Try updating your profile or preferences!</p>
        ) : (
          <ul>
            {matchSuggestions.map(user => (
              <li key={user.id}>
                <span>{user.display_name || user.name}</span>
                <button
                  disabled={connectionRequests[user.id] === 'pending'}
                  onClick={() => handleConnectWithSuggestion(user.id)}
                >
                  {connectionRequests[user.id] === 'pending' ? 'Requested' : 'Connect'}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
);

export default SuggestionsModal;